import userTranslationsHelper from "../../../../languages/user-translations.helper";
import {
  CandidatureDeleteOrderDriverHasCandidatureError,
  CandidatureDeleteOrderErrorType,
  CandidatureDeleteOrderOrderInProgressError,
  CandidatureDeleteOrderOrderNotExistsError,
  CandidatureDeleteOrderTaxiDriverAssociationNotExistsError,
  CandidatureDeleteOrderTaxiDriverContractNotValidError,
  CandidatureDeleteOrderTaxiRailyContractNotExistsError,
} from "./candidature-delete-order-error";

const createTaxiDriverAssociationNotExistsError =
  (): CandidatureDeleteOrderTaxiDriverAssociationNotExistsError => {
    const translations =
      userTranslationsHelper.getDriverDetailsActiveRoutePlansTranslations()
        .deleteOrder.apiErrors;

    return {
      message: translations.taxiDriverAssociationNotExistsErrorLabel,
      params: {},
      type: CandidatureDeleteOrderErrorType.TAXI_DRIVER_ASSOCIATION_NOT_EXISTS,
    };
  };

const createOrderNotExistsError =
  (): CandidatureDeleteOrderOrderNotExistsError => {
    const translations =
      userTranslationsHelper.getDriverDetailsActiveRoutePlansTranslations()
        .deleteOrder.apiErrors;

    return {
      message: translations.orderNotExistsErrorLabel,
      params: {},
      type: CandidatureDeleteOrderErrorType.ORDER_NOT_EXISTS,
    };
  };

const createOrderInProgressError =
  (): CandidatureDeleteOrderOrderInProgressError => {
    const translations =
      userTranslationsHelper.getDriverDetailsActiveRoutePlansTranslations()
        .deleteOrder.apiErrors;

    return {
      message: translations.orderInProgressErrorLabel,
      params: {},
      type: CandidatureDeleteOrderErrorType.ORDER_IN_PROGRESS,
    };
  };

const createTaxiDriverContractNotValidError =
  (): CandidatureDeleteOrderTaxiDriverContractNotValidError => {
    const translations =
      userTranslationsHelper.getDriverDetailsActiveRoutePlansTranslations()
        .deleteOrder.apiErrors;

    return {
      message: translations.taxiDriverContractNotValidErrorLabel,
      params: {},
      type: CandidatureDeleteOrderErrorType.TAXI_DRIVER_CONTRACT_NOT_VALID,
    };
  };

const createTaxiRailyContractNotValidError =
  (): CandidatureDeleteOrderTaxiRailyContractNotExistsError => {
    const translations =
      userTranslationsHelper.getDriverDetailsActiveRoutePlansTranslations()
        .deleteOrder.apiErrors;

    return {
      message: translations.taxiRailyContractNotValidErrorLabel,
      params: {},
      type: CandidatureDeleteOrderErrorType.TAXI_RAILY_CONTRACT_NOT_VALID,
    };
  };

const createDriverHasCandidatureError =
  (): CandidatureDeleteOrderDriverHasCandidatureError => {
    const translations =
      userTranslationsHelper.getDriverDetailsActiveRoutePlansTranslations()
        .deleteOrder.apiErrors;

    return {
      message: translations.driverHasCandidatureErrorLabel,
      params: {},
      type: CandidatureDeleteOrderErrorType.DRIVER_HAS_CANDIDATURE,
    };
  };

const candidatureDeleteOrderErrorFactory = {
  createTaxiDriverAssociationNotExistsError,
  createOrderNotExistsError,
  createOrderInProgressError,
  createTaxiDriverContractNotValidError,
  createTaxiRailyContractNotValidError,
  createDriverHasCandidatureError,
};

export default candidatureDeleteOrderErrorFactory;
